"use client";

import { ShieldCheck, FlaskConical, FileText, Snowflake, Microscope, Zap, Target, Beaker } from "lucide-react";
export default function Trustbar() {
  const stamps = [{
    label: "RESEARCH GRADE",
    year: "2024",
    icon: FlaskConical,
    shape: "circle"
  }, {
    label: "LAB TESTED",
    year: "2024",
    icon: Microscope,
    shape: "oval"
  }, {
    label: "COA VERIFIED",
    year: "2024",
    icon: FileText,
    shape: "circle"
  }, {
    label: "COLD STORED",
    year: "2024",
    icon: Snowflake,
    shape: "oval"
  }, {
    label: "PURITY ASSURED",
    year: "2024",
    icon: ShieldCheck,
    shape: "circle"
  }, {
    label: "ELITE FORMULA",
    year: "2024",
    icon: Zap,
    shape: "oval"
  }, {
    label: "PRECISION BATCH",
    year: "2024",
    icon: Target,
    shape: "circle"
  }, {
    label: "LAB ANALYZED",
    year: "2024",
    icon: Beaker,
    shape: "oval"
  }];
  const loopStamps = [...stamps, ...stamps];
  return <section data-section-id="1391" id="operational-trust-bar" className="bg-background text-foreground relative overflow-hidden border-t border-b border-border">
      <div className="absolute top-4 left-4 md:top-6 md:left-8 font-mono text-[0.7rem] tracking-[0.1em] text-muted-foreground z-10">
        IH-PROTOCOL / 001
      </div>
      

      <div className="py-16 md:py-20 px-6 md:px-10">
        <div className="max-w-7xl mx-auto text-center">
          <p className="font-default text-[0.8125rem] tracking-[0.18em] uppercase !text-[rgba(251,189,35,1)]">
            § Nº 01 — Quality Assurance Protocols
          </p>

          

          <p className="font-default italic text-foreground text-lg md:text-2xl leading-relaxed max-w-3xl mx-auto">
            Engineered for elite performance, verified by rigorous laboratory standards —
          </p>
        </div>

        <div className="mt-12 md:mt-16 relative">
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-32 z-10" style={{
          background: "linear-gradient(to right, var(--background) 0%, transparent 100%)"
        }} />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-32 z-10" style={{
          background: "linear-gradient(to left, var(--background) 0%, transparent 100%)"
        }} />

          
        </div>
      </div>

      <div className="h-4 w-full" style={{
      backgroundImage: "linear-gradient(to right, var(--primary) 0, var(--primary) 4px, transparent 4px, transparent 10px)",
      backgroundSize: "10px 2px",
      backgroundRepeat: "repeat-x",
      backgroundPosition: "center"
    }} />

      <style>{`
        @keyframes pressMarqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .press-marquee-track {
          animation: pressMarqueeScroll 40s linear infinite;
        }
        .press-marquee-track:hover {
          animation-play-state: paused;
        }
        .press-stamp {
          transition: transform 700ms cubic-bezier(0.65, 0, 0.35, 1);
        }
        .press-stamp:hover {
          transform: rotate(-6deg);
        }
      `}</style>
    </section>;
}